import type { BaseEntity } from './BaseEntity';
import type { ConsumedInventoryItem } from './ConsumedInventoryItem';
import type { Item } from './Item';
import type { Product } from './Product';

export interface ProductItem extends BaseEntity {
  quantity: number;
  itemId: number;
  item?: Item;
  productId: number;
  product?: Product;
  productBatchQuantity?: number;
  standardProductBatchQuantity?: number;
  remainingProductBatchQuantity?: number;
  productBatchQuantityMet?: boolean;
  calculatedConsumedInventoryItems?: ConsumedInventoryItem[]
  notes?: string;
  averageItemCostPerBatchPound?: number;
  averageItemCostPerStandardBatch?: number;
  calculatedItemCost?: number
}

type ValidationResult = { issues: { message: string; path: (keyof ProductItem)[] }[] };

export function validate(productItem: Partial<ProductItem>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!productItem.itemId) {
    issues = [...issues, { message: 'Item is required', path: ['itemId'] }];
  }

  if (!productItem.quantity) {
    issues = [...issues, { message: 'Quantity is required', path: ['quantity'] }];
  }

  return { issues };
}